import { NButton } from '@nemo/react';
import { useMixpanelContext } from '../../providers/MixpanelContext';
import { useUserContext } from '../../providers/UserContext';
import { Session } from '../../utils/types';
import {
  formatTimeRange,
  gseRangeToCEFR,
  getIsJoinBtnActive,
  getClassStatus,
} from '../../utils/utils';
import { ReactComponent as ContentSenstivity } from '../../assets/image/report.svg';
import SessionStatusBadge from '../shared/SessionStatusBadge';
import Tooltip from '../shared/Tooltip';
import StandaloneLink from '../shared/StandaloneLink';

interface TableSessionRowProps {
  session: Session;
  // timezone: string;
  isLastRow?: boolean;
}

function TableSessionRow({ session, isLastRow }: TableSessionRowProps) {
  const dateRange = formatTimeRange(session.date, session.duration);
  const isJoinBtnActive = getIsJoinBtnActive(session.date);
  const status = getClassStatus(session);

  const { tutorByIesId } = useUserContext();
  const { mixpanelTrackEvent } = useMixpanelContext();

  const handleStartClassBtn = () => {
    // Mixpanel metric tutor start session click:
    mixpanelTrackEvent('TutorPortalJoinClick', {
      tutor: tutorByIesId,
      sessionId: session.id,
    });
    window.open(session.link, '_blank');
  };

  return (
    <section
      className={`table-session-row-section ${isLastRow ? 'last-row' : ''} ${isJoinBtnActive && status === 'Confirmed' ? 'join-active' : ''} slign-center`}
    >
      <div className="table-column-titles flex align-center">
        <div className="time">
          <p className="b2-regular">{dateRange}</p>
        </div>
        <div className="duration flex space-between">
          <p className="b2-regular">{`${session.duration} min`}</p>
          <SessionStatusBadge status={status} />
        </div>
        <div className="group flex space-between">
          <p className="b2-regular">{`${session.enrollments}/6`}</p>
          <p className="b2-regular">{`${session.isPrivateGroup ? 'Private' : 'Public'}`}</p>
        </div>
        <div className="topic flex column">
          <p className="c1 superscript no-margin">
            {`${session.simplifiedLevel} · ${gseRangeToCEFR(session.minGSE, session.maxGSE)}`}{' '}
          </p>
          <div className="group-info flex gap-4">
            {session.contentSensitivity && (
              <Tooltip content="Adapted topic">
                <ContentSenstivity />
              </Tooltip>
            )}
            <p className="b2 no-margin">{`${session.topic}`}</p>
          </div>
        </div>
        <div className="resources flex">
          <div className="files">
            {session.teacher_guide && (
              <StandaloneLink
                title="Teacher guide"
                link={session.teacher_guide ? session.teacher_guide.valueOf() : ''}
                mixpanelEventName="TutorPortalTeacherGuideClick"
                sessionId={session.id}
              />
            )}

            {session.class_material && (
              <StandaloneLink
                title="Class slides"
                link={session.class_material ? session.class_material.valueOf() : ''}
                mixpanelEventName="TutorPortalClassSlidesClick"
                sessionId={session.id}
              />
            )}
          </div>
          {isJoinBtnActive && status === 'Confirmed' && (
            <NButton variant="primary" size="sm" onClick={handleStartClassBtn}>
              Start class
            </NButton>
          )}
        </div>
      </div>
    </section>
  );
}

export default TableSessionRow;
